import './styles/global.scss'
import { RoutesPage } from './routes/RoutesPage'
// import { useEffect } from 'react'
// import { useDispatch } from 'react-redux'
// import { setUserPhone } from './store/slice/auth/authenticationSlice'
// import { setCurrentRoute, setNavigateCallback } from './services/axois'

function App() {
  // const dispatch = useDispatch()

  // useEffect(() => {
  //   dispatch(setUserPhone(null));
  // }, [dispatch]);

  return (
    <>
      <RoutesPage />
    </>
  )
}

export default App
